import { useState } from 'react'
import { motion } from 'framer-motion'
import { Download, Share, Plus, X } from 'lucide-react'
import useInstallPrompt from '../../hooks/useInstallPrompt'
import BottomSheet from './BottomSheet'

// Subtle "Install app" affordance. On Android/desktop it calls the native
// prompt; on iOS (no beforeinstallprompt) it opens Add-to-Home-Screen steps.
const InstallPrompt = ({ className = '' }) => {
  const { canInstall, promptInstall, isInstalled, isIOS, dismissed, dismiss } = useInstallPrompt()
  const [sheetOpen, setSheetOpen] = useState(false)

  if (isInstalled || dismissed || !canInstall) return null

  const handleClick = () => {
    if (isIOS) setSheetOpen(true)
    else promptInstall()
  }

  return (
    <>
      <div className={`flex items-center gap-1 ${className}`}>
        <motion.button
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          whileTap={{ scale: 0.95 }}
          onClick={handleClick}
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-container px-3 py-1.5 text-xs font-bold text-primary-on-container"
          aria-label="Install app"
        >
          <Download className="w-3.5 h-3.5" />
          Install app
        </motion.button>
        <button
          onClick={dismiss}
          aria-label="Dismiss install prompt"
          className="text-slate-300 hover:text-ink-3 transition-colors p-1"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      <BottomSheet open={sheetOpen} onClose={() => setSheetOpen(false)} title="Install oriondev">
        <p className="text-sm text-ink-2 mb-5">
          Add oriondev to your home screen for an app-like, full-screen experience.
        </p>
        <ol className="space-y-4">
          <li className="flex items-center gap-3">
            <span className="shape-well h-9 w-9 shrink-0">
              <Share className="w-4 h-4" />
            </span>
            <span className="text-sm text-ink-2">
              Tap the <span className="font-medium">Share</span> button in Safari&apos;s toolbar.
            </span>
          </li>
          <li className="flex items-center gap-3">
            <span className="shape-well h-9 w-9 shrink-0">
              <Plus className="w-4 h-4" />
            </span>
            <span className="text-sm text-ink-2">
              Choose <span className="font-medium">Add to Home Screen</span>, then tap Add.
            </span>
          </li>
        </ol>
      </BottomSheet>
    </>
  )
}

export default InstallPrompt
